import { SagaIterator } from "redux-saga"
import { all, fork } from "redux-saga/effects"
import sagas from "./app/sagas"

export default function* root(): SagaIterator {
  yield all(sagas.map(saga => fork(saga)))
}
